import {
  DashboardAsset,
  DashboardProject,
  DashboardRole,
  DashboardSettingsState,
} from './types.js';
import { DASHBOARD_MESSAGE_THREADS } from './messages.mock';

export const DASHBOARD_PROJECTS: DashboardProject[] = [
  {
    id: 'v8-turbo',
    name: 'V8-Turbo Engine Assembly',
    companyName: 'AutoDynamics GmbH',
    updatedAtLabel: 'Updated 2h ago',
    status: 'in_production',
    collaborators: ['AL', 'MK'],
  },
  {
    id: 'hydraulic-lift',
    name: 'Hydraulic Lift System P9',
    companyName: 'HeavyLift Solutions',
    updatedAtLabel: 'Updated yesterday',
    status: 'delivered',
    collaborators: ['SR'],
  },
  {
    id: 'robotic-arm',
    name: 'Robotic Arm Interface',
    companyName: 'TechFlow Manufacturing',
    updatedAtLabel: 'Updated 4d ago',
    status: 'in_production',
    collaborators: ['JR', 'KT'],
  },
];

export const DASHBOARD_ASSETS: DashboardAsset[] = [
  {
    id: 'engine-main-v2',
    name: 'Engine_Main_V2.glb',
    type: 'model',
    readiness: 'ready',
    sizeLabel: '45.2 MB',
    updatedAtLabel: '2h ago',
    description: 'Primary 3D assembly model optimized for staged review and guided manual playback.',
    metadata: [
      { label: 'Uploaded', value: 'Oct 12, 2023' },
      { label: 'Version', value: '4.0.2-ALPHA' },
      { label: 'Polygons', value: '1.2M' },
      { label: 'Vertices', value: '840K' },
    ],
    tags: ['Related Products', 'Accessories', 'Tools', 'Spare Parts'],
  },
  {
    id: 'hero-shot',
    name: 'Product_Hero_Shot.png',
    type: 'image',
    readiness: 'ready',
    sizeLabel: '12.8 MB',
    updatedAtLabel: '5h ago',
    description: 'Marketing-safe hero image used for launch materials and project detail pages.',
    metadata: [
      { label: 'Dimensions', value: '3840 x 2160' },
      { label: 'Color space', value: 'sRGB' },
      { label: 'Usage', value: 'Launch collateral' },
    ],
  },
  {
    id: 'assembly-guide',
    name: 'Assembly_Guide_V2.pdf',
    type: 'pdf',
    readiness: 'ready',
    sizeLabel: '2.4 MB',
    updatedAtLabel: '3h ago',
    description: 'Reference PDF attached to the active manual release and client review thread.',
    metadata: [
      { label: 'Pages', value: '42' },
      { label: 'Security', value: 'Internal share' },
      { label: 'Usage', value: 'Reviewer packet' },
    ],
  },
  {
    id: 'tutorial-video',
    name: 'Assembly_Tutorial_Full.mp4',
    type: 'video',
    readiness: 'ready',
    sizeLabel: '245.5 MB',
    updatedAtLabel: 'Oct 12, 2023',
    description: 'Recorded walkthrough used to validate timing, pacing, and support handoff.',
    metadata: [
      { label: 'Duration', value: '06:42' },
      { label: 'Resolution', value: '4K UHD' },
      { label: 'Codec', value: 'H.264' },
    ],
  },
];

export const DASHBOARD_THREADS = DASHBOARD_MESSAGE_THREADS;

export const DASHBOARD_SETTINGS: DashboardSettingsState = {
  fullName: '',
  email: '',
  theme: 'light',
};

export function getDashboardBadge(role: DashboardRole): string {
  switch (role) {
    case 'client':
      return 'Client Dashboard';
    case 'superadmin':
      return 'Superadmin Dashboard';
    case 'admin':
    default:
      return 'Admin Dashboard';
  }
}

export function getDashboardSubtitle(role: DashboardRole): string {
  switch (role) {
    case 'client':
      return 'Review project tracking, assets, communication, and account preferences in a single workspace.';
    case 'superadmin':
      return 'Manage the workspace shell while keeping future global controls ready for expansion.';
    case 'admin':
    default:
      return 'Manage projects, assets, messages, and account settings from a single scrollable workspace.';
  }
}
